import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { WebinarResistrationList } from './WebinarResistrationList';
import { WebinarGetRecordingList } from './WebinarGetRecordingList';
const LENDERIQ_TABS = [
  {
    tabIndex: 0,
    tabId: 'webinar-registration',
    tabName: 'Webinar Registration',
  },
  {
    tabIndex: 1,
    tabId: 'webinar-get-recording',
    tabName: 'Webinar Get Recording',
  },
];

const WebinarFramework = (): JSX.Element => {
  const [webinarTabs, setwebinarTabs] = useState(LENDERIQ_TABS);
  const [searchParams, setSearchParams] = useSearchParams({ tabIndex: '0' });

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set('tabIndex', JSON.stringify(tabId));
      return params;
    });
  };
  const tabIndex = searchParams.get('tabIndex');
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <div className="main-container podcasts">
      <div className="podcasts-tab">
        {webinarTabs.map((tab, index) => {
          const { tabIndex, tabId, tabName } = tab;

          return (
            <div
              key={tabId}
              className={`item ${tabIndex === parsedTabIndex ? 'active' : ''}`}
              onClick={() => handleTabChange(tabIndex)}
            >
              {tabName}
            </div>
          );
        })}
      </div>
      <>
        {parsedTabIndex === 0 && <WebinarResistrationList />}
        {parsedTabIndex === 1 && <WebinarGetRecordingList />}
      </>
    </div>
  );
};

export default WebinarFramework;
